import { DatePicker, Flex, Typography } from "antd";
import { useState } from "react";
import type { IntlShape } from "@formatjs/intl";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { EditablePencilIcon } from "../antd/EditableSelector";
import { NoData } from "./NoDataComp";

type EditableDatePickerProps = {
  variableName: string;
  variableValue?: string | null;
  intl: IntlShape;
  onChange?: (variableName: string, isoValue: string | null) => void;
  readOnly?: boolean;
};

export const EditableDatePicker = (props: EditableDatePickerProps) => {
  const { variableName, variableValue, intl, onChange, readOnly = false } = props;

  const [editing, setEditing] = useState(false);

  const displayValue = variableValue
    ? intl.formatMessage({ id: "short_date" }, { value: new Date(variableValue) })
    : null;

  const handleChange = (date: Dayjs | null) => {
    setEditing(false);
    const isoValue = date ? date.format("YYYY-MM-DD") : null;
    if (isoValue !== variableValue) {
      onChange?.(variableName, isoValue);
    }
  };

  if (editing) {
    return (
      <DatePicker
        autoFocus
        open
        defaultValue={variableValue ? dayjs(variableValue) : undefined}
        format="DD/MM/YYYY"
        showNow={false}
        onChange={handleChange}
        onOpenChange={(open) => {
          if (!open) setEditing(false);
        }}
      />
    );
  }

  return (
    <Flex align="center" gap={4}>
      {displayValue ? (
        <Typography.Text>{displayValue}</Typography.Text>
      ) : (
        <NoData intl={intl} />
      )}
      {!readOnly && (
        <span
          role="button"
          tabIndex={0}
          onClick={() => setEditing(true)}
          onKeyDown={(e) => e.key === "Enter" && setEditing(true)}
          style={{ cursor: "pointer", lineHeight: 1 }}
        >
          <EditablePencilIcon />
        </span>
      )}
    </Flex>
  );
};
